import React from 'react';
import Chart from './Chart';

export default function PieChart({datalabels=false, ...props}) {

  const pieOption = {
    chart: {
      type: 'pie'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: datalabels,
          format: '<b>{point.name}</b>: {point.percentage:.1f} %',
          color: '#666',
          style: {
            fontWeight: 'normal'
          }
        }
      }
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    accessibility: {
      point: {
        valueSuffix: '%'
      }
    },
    series: [{
      visible: true
    }]
  }

  function dataOption(data) {
    return {...pieOption, series: [{ data: data, visible: true }]}
  }

  return (
    <Chart
      options={dataOption(props.data)}
      legendOptions={props.legendOptions}
    />
  )
}
